"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FluidToggleType = void 0;
var FluidToggleType;
(function (FluidToggleType) {
    FluidToggleType["SWITCH"] = "switch";
    FluidToggleType["CHECKBOX"] = "checkbox";
    FluidToggleType["FLAG"] = "flag";
    FluidToggleType["LINK"] = "link";
    FluidToggleType["CUSTOM"] = "custom";
    FluidToggleType["TEXT"] = "text";
    FluidToggleType["TOGGLE_CHIP"] = "toggle-chip";
    FluidToggleType["CHIP"] = "chip";
    FluidToggleType["FAVORITE"] = "favorite";
})(FluidToggleType = exports.FluidToggleType || (exports.FluidToggleType = {}));
